__turbopack_context__.v({
  "container": "ApplyStepIcon-module__5d-gyG__container",
  "fadeInItems": "ApplyStepIcon-module__5d-gyG__fadeInItems",
  "icon": "ApplyStepIcon-module__5d-gyG__icon",
  "spacing--lg": "ApplyStepIcon-module__5d-gyG__spacing--lg",
  "spacing--md": "ApplyStepIcon-module__5d-gyG__spacing--md",
  "spacing--sm": "ApplyStepIcon-module__5d-gyG__spacing--sm",
  "spacing--xl": "ApplyStepIcon-module__5d-gyG__spacing--xl",
  "spacing--xs": "ApplyStepIcon-module__5d-gyG__spacing--xs",
  "spacing--xxl": "ApplyStepIcon-module__5d-gyG__spacing--xxl",
  "spacing--xxs": "ApplyStepIcon-module__5d-gyG__spacing--xxs",
  "spacing--xxxl": "ApplyStepIcon-module__5d-gyG__spacing--xxxl",
  "spacing--xxxs": "ApplyStepIcon-module__5d-gyG__spacing--xxxs",
});
